import React from "react";
import { Modal, Input, Icon } from "antd";
import PropTypes from "prop-types";
import { formatCredit } from "../utils/formatters";

/**
 * DeleteWalletModal - Modal for confirming wallet deletion
 */
const DeleteWalletModal = ({
  visible,
  record,
  note,
  loading,
  onNoteChange,
  onCancel,
  onSubmit,
}) => {
  if (!record) return null;

  const isFormValid = note && note.trim() !== "";

  return (
    <Modal
      title="Delete Wallet"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      confirmLoading={loading}
      okText="Delete"
      okType="danger"
      okButtonProps={{ disabled: !isFormValid }}
      maskClosable={false}
    >
      <div style={{ marginBottom: 16, color: "#ff4d4f" }}>
        <Icon type="warning" style={{ marginRight: 8 }} />
        Are you sure you want to delete this wallet?
      </div>
      <div style={{ marginBottom: 16 }}>
        <label>
          Credit Available: <strong>{formatCredit(record.credit_available)}</strong>
        </label>
      </div>
      <div>
        <label>Note: <span style={{ color: '#ff4d4f' }}>*</span></label>
        <Input.TextArea
          style={{ marginTop: 8 }}
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          placeholder="Reason for deletion..."
          rows={3}
        />
      </div>
    </Modal>
  );
};

DeleteWalletModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  record: PropTypes.object,
  note: PropTypes.string,
  loading: PropTypes.bool,
  onNoteChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

DeleteWalletModal.defaultProps = {
  record: null,
  note: "",
  loading: false,
};

export default DeleteWalletModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/modals/DeleteWalletModal.js